<template>
  <div class="card pt-4 pl-4 pr-4 pb-4 comment-section" @scroll="onScroll">
    <span class="text-muted text-center mt-auto mb-auto" v-if="comments.length <= 0">No comments now</span>
    <div v-for="comment in comments" :key="comment.id">
      <div class="media align-items-center">
        <span class="avatar avatar-sm rounded-circle">
          <img
            alt="Image placeholder"
            :src="comment.profile ? comment.profile : require('@/assets/default_profile_picture.png')"
          />
        </span>
        <div class="media-body ml-2 d-lg-block">
          <span class="mb-0 text-sm font-weight-bold text-black pointer-cursor">{{comment.name }}</span>
        </div>
      </div>
      <p class="ml-1 mt-2 text-sm">{{ comment.comment }}</p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { GET_POST_COMMENTS } from '@/store/actions.type'

export default {
  props: ['id'],
  name: 'comment-list',
  data() {
    return {
      nextPage: 1,
      isLoadingComment: false,
      isAllCommentLoaded: false
    }
  },
  created() {
    this.$store
      .dispatch(GET_POST_COMMENTS, {
        id: this.id,
        page: this.nextPage
      })
      .then(() => {
        this.nextPage++
        this.scrollToBottom()
      })
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isOnBottom = true
      } else {
        this.isOnBottom = false
      }
      if (
        scrollTop <= 50 &&
        !this.isLoadingComment &&
        !this.isAllCommentLoaded
      ) {
        this.isLoadingComment = true
        this.$store
          .dispatch(GET_POST_COMMENTS, {
            id: this.id,
            page: this.nextPage
          })
          .then(data => {
            this.isLoadingComment = false
            if (data.length <= 0) {
              this.isAllCommentLoaded = true
              return
            }
            this.nextPage++
          })
      }
    },
    scrollToBottom() {
      const container = document.getElementsByClassName('comment-section')[0]
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    }
  },
  computed: {
    ...mapState({
      comments: state => state.newsfeed.comments
    })
  }
}
</script>

<style scoped>
.comment-section {
  min-height: 300px;
  max-height: 800px;
  overflow-y: auto;
}
</style>
